/**
 * Cached featured items.
 *
 * IndexPage remounts when the sort order changes, which re-ran the fetch and
 * made the strip flash and reshuffle even though nothing about it depends on
 * the sort. The strip is always "newest Updates", so the result is reused
 * across remounts until it goes stale.
 *
 * This file used to also track which ids to SUPPRESS from the list below —
 * Updates were hidden there, and the ids were how the grid knew which rows to
 * leave out. They are no longer hidden, so that half is gone.
 */
let cache = null;
const MAX_AGE_MS = 5 * 60 * 1000;
export function cachedFeatured() {
  if (!cache) return null;
  if (Date.now() - cache.at > MAX_AGE_MS) return null;
  return cache.items;
}
export function cacheFeatured(items) {
  cache = {
    at: Date.now(),
    items
  };
}

/**
 * Live updates.
 *
 * The strip fetches once and caches, so a bot post did not appear until a
 * reload or until the cache aged out — while the discussion list underneath it
 * updated over the websocket. `markFeaturedStale` drops the cache and asks the
 * mounted header to refetch; nothing happens if the strip is not on screen.
 */
let onStale = null;
export function setFeaturedRefresher(fn) {
  onStale = fn;
}
export function markFeaturedStale() {
  cache = null;
  onStale?.();
}